module.exports = __webpack_public_path__ + "public/img/xcs-2.37b61152.jpg";